import axios from "axios";
const BACKENDS = {
  oeson: "https://us-central1-backend-metbrains.cloudfunctions.net/api/api",
  metbrains: "https://us-central1-backend-metbrains.cloudfunctions.net/api/api",
  dev: "http://localhost:8000/api",
};

// read preference (default to oeson if not set)
const preference = "metbrains";
// const preference = "dev";

const instance = axios.create({
  baseURL: BACKENDS[preference],
});

// helper to switch at runtime
export const setBackendPreference = (key) => {
  if (BACKENDS[key]) {
    localStorage.setItem("backend_preference", key);
    instance.defaults.baseURL = BACKENDS[key];
  } else {
    console.warn("Invalid backend key:", key);
  }
};

export default instance;